"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Alert = _interopRequireDefault(require("@cimpress/react-components/lib/Alert"));

var NotificationAlert = function NotificationAlert(props) {
  return _react["default"].createElement(_Alert["default"], {
    type: props.type,
    title: props.title,
    message: props.message,
    dismissible: props.dismissible,
    onDismiss: props.alertClose
  });
};

NotificationAlert.propTypes = {
  type: _propTypes["default"].string,
  title: _propTypes["default"].string,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  alertClose: _propTypes["default"].func,
  dismissible: _propTypes["default"].bool
};
NotificationAlert.defaultProps = {
  type: 'warning',
  title: '',
  dismissible: true,
  alertClose: function alertClose() {}
};
var _default = NotificationAlert;
exports["default"] = _default;